















import SideviewButton from '@/components/sideview-button'
import MapView from '@/components/map-view'
import VerticalSplitter from '@/components/vertical-splitter'
import DetailsView from '@/components/details-view'
import TimeControl from '@/components/time-control'

const SMALLSCREEN = 568
const MAPMIN = 320
const DETAILSMIN = 248

export default {
  name: 'main-view',
  components: {
    SideviewButton,
    MapView,
    VerticalSplitter,
    DetailsView,
    TimeControl
  },
  data() {
    return {
      viewportWidth: undefined,
      detailsVisible: true
    }
  },
  computed: {
    smallView() {
      return this.viewportWidth < SMALLSCREEN
    },
    splitterVisible() {
      return !this.smallView && this.detailsVisible
    },
    appWidth() {
      return this.splitterVisible ? this.viewportWidth : 2 * this.viewportWidth
    },
    appLeft() {
      // return (!this.splitterVisible && !this.detailsVisible) ? -this.viewportWidth : 0
      return (this.splitterVisible || this.detailsVisible) ? 0 : -this.viewportWidth
    },
    splitRatio() {
      return this.$store.state.persistent.splitRatio
    },
    freeWidth() {
      return this.viewportWidth - MAPMIN - DETAILSMIN
    },
    splitterLeft() {
      return Math.round(DETAILSMIN + (this.splitRatio * this.freeWidth) - 10)
    },
    mapWidth() {
      return this.splitterVisible ? this.viewportWidth - this.splitterLeft - 11 : this.viewportWidth
    },
    detailsWidth() {
      return this.splitterVisible ? this.splitterLeft + 10 : this.viewportWidth
    }
    // ,
    // center() {
    //  return this.$store.state.persistent.center
    // }
  },
  watch: {
    smallView() {
      this.detailsVisible = !this.smallView
    }
    // center() {
    //  setTimeout(() => {
    //    this.detailsVisible = true
    //  }, 300)
    // }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    // this.detailsVisible = !this.smallView
    setTimeout(this.handleResize, 500)
    this.handleResize()
  },
  methods: {
    handleResize() {
      this.viewportWidth = window.innerWidth
    },
    toggleView() {
      this.detailsVisible = !this.detailsVisible
    },
    beginTouchMove() {
      window.addEventListener('touchmove', this.touchMove)
      window.addEventListener('touchend', this.endTouchMove)
      window.addEventListener('touchleave', this.endTouchMove)
      this.beginMove()
    },
    beginMouseMove(e) {
      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('mouseup', this.endMouseMove)
      window.addEventListener('mouseleave', this.endMouseMove)
      this.beginMove()
    },
    endTouchMove() {
      window.removeEventListener('touchmove', this.touchMove)
      window.removeEventListener('touchend', this.endTouchMove)
      window.removeEventListener('touchleave', this.endTouchMove)
      this.endMove()
    },
    endMouseMove() {
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('mouseup', this.endMouseMove)
      window.removeEventListener('mouseleave', this.endMouseMove)
      this.endMove()
    },
    beginMove() {
      // this.disableTransitions()
      this.$store.dispatch('runtime/showDragSurface')
    },
    endMove() {
      // this.enableTransitions()
      this.$store.dispatch('runtime/hideDragSurface')
    },
    doMove(e) {
      let ratio = (e.x - DETAILSMIN) / this.freeWidth
      if (ratio < 0) {
        ratio = 0
      } else if (ratio > 1) {
        ratio = 1
      }
      this.$store.dispatch('persistent/setSplitRatio', ratio)
    },
    touchMove(e) {
      this.doMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
    },
    mouseMove(e) {
      this.doMove({ x: e.clientX, y: e.clientY })
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/main-view.vue